enum SearchType {
  Documents = "Documents",
  Conversations = "Conversations",
}
export default SearchType;
